module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "itr"
    }
  }, [_c('h1', {
    staticClass: "fmbmtitleb"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _vm._v("Introduction")]), _vm._v(" "), _c('div', {
    staticClass: "dis_imgbdy"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/4-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("We hope that kids who are already hooked on calligraphy as well as kids eager to begin will enjoy this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you’ve already tried some calligraphy alphabets, you are probably ready for more. Calligraphy, as you already know, opens many new doors and invites you to explore a wonderful world of shapes and colors and techniques.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If this book is your first experience with calligraphy, you’ve come to the right place! "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 1")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(", and "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" review some of the basics of lettering and the art materials you will be using. The instructions in the later chapters will be easy to follow if you spend some time doing the exercises and practicing the techniques in these first chapters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For those of you already familiar with calligraphy, it’s still worth taking a look at the opening chapters, especially if you haven’t picked up your calligraphy pens lately.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("1–2–3 Calligraphy")]), _vm._v(" offers something for everyone: new ways to do “old” alphabets and some other alphabets you are probably seeing for the first time. Plus it presents projects and techniques that give you many new ways to use your calligraphy, such as making signs, designing stationery, addressing colorful envelopes, making calligrams (calligraphic pictures), and more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book even looks into some of the basic rules and steps of layout and design so that you can make calligraphy art, such as poems or quotations to hang on the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Who knows? This could be the beginning—or the continuation—of a lifelong interest.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b02fc99","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781454936534_itr.vue
// module id = 75
// module chunks = 0